var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modo_de_aislamiento",
    clipPath: "url(#clip0_851_3911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 2.73463C29.5146 2.73463 37.2654 10.4854 37.2654 20C37.2654 29.5146 29.5146 37.2654 20 37.2654C10.4854 37.2654 2.73463 29.5146 2.73463 20C2.73463 10.4854 10.4854 2.73463 20 2.73463ZM20 0C8.94822 0 0 8.94822 0 20C0 31.0518 8.94822 40 20 40C31.0518 40 40 31.0518 40 20C40 8.94822 31.0518 0 20 0Z",
    fill: "#A6FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4403 15.8092H15.5018V28.8512H11.4403V15.8092ZM13.463 9.33667C14.7575 9.33667 15.8093 10.3884 15.8093 11.6829C15.8093 12.9774 14.7575 14.0292 13.463 14.0292C12.1685 14.0292 11.1167 12.9774 11.1167 11.6829C11.1167 10.3884 12.1685 9.33667 13.463 9.33667Z",
    fill: "#A6FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.0581 15.809H21.9416V17.5889H21.9901C22.5403 16.5695 23.851 15.4854 25.8251 15.4854C29.9351 15.4854 30.6795 18.1876 30.6795 21.6989V28.851H26.6342V22.508C26.6342 20.987 26.6018 19.0452 24.5306 19.0452C22.4594 19.0452 22.1034 20.6957 22.1034 22.3947V28.851H18.0581V15.809Z",
    fill: "#A6FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851_3911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.499b4f8057110cba94e1405fd7a3c2dc.svg";
export { ForwardRef as ReactComponent };